import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { setInitialStoreState } from '../../../../../../common/utils/set-initial-store-state';
import { UliBriefFacade } from './uli-brief.facade';

@Injectable({
  providedIn: 'root',
})
export class UliBriefGuard {
  constructor(private uliBriefFacade: UliBriefFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { id },
      queryParams: { compartmentId, type },
    } = route.parent;

    this.uliBriefFacade.getUliBrief(compartmentId, type, id);
    return of(true);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.uliBriefFacade);
  }
}
